<template>
  <div class="container-fluid">
    <div class="header">
      <div class="logo">
        <img src="../assets/theme/logo.png">
      </div>
      <div class="menu">
        <ul>
          <li><a href="#">Home</a></li>
          <li><a href="#">About Us</a></li>
          <li><a href="#">Stats</a></li>
          <li><a href="#">FAQ</a></li>
          <li><a href="#">Contact Us</a></li>
        </ul>
      </div>
    </div>
    <div class="content">
      <div class="top-banner">
        <img src="../assets/theme/t-banner.png">
      </div>
      <England :data="gb" :reload-time="reloadTime" @reload="getResults" />
      <Germany :data="de" :reload-time="reloadTime" @reload="getResults" />
      <Russia :data="ru" :reload-time="reloadTime" @reload="getResults" />
    </div>
    <div class="footer"></div>
  </div>
</template>
<script>
import LottoService from '@/services/lottoService.js'

import England from './components/EnglandResult.vue'
import Germany from './components/GermanyResult.vue'
import Russia from './components/RussiaResult.vue'

export default {
  components: {
    England,
    Germany,
    Russia
  },
  data() {
    return {
      Results: null,
      IntervalReload: null,
      TimeoutReload: null,
      reloadTime: 0
    }
  },
  computed: {
    gb() {
      if(this.Results) {
        return this.Results.gb
      }else{
        return null
      }
    },
    de() {
      if(this.Results) {
        return this.Results.de
      }else{
        return null
      }
    },
    ru() {
      if(this.Results) {
        return this.Results.ru
      }else{
        return null
      }
    }
  },
  methods: {
    getResults() {
      LottoService.getResults().then((response) => {
        if (response.status === 'success') {
          console.log('response.data', response.data.gb)
          this.Results = response.data
          this.reloadTime = new Date().getTime()
        }
      })
      .finally(()=>{
        console.log('get results finally!!!')
        clearTimeout(this.TimeoutReload)
        this.TimeoutReload = setTimeout(()=>{
          this.getResults()
        }, 45000)
      })
    }
  },
  created() {
    this.getResults()
    /*this.IntervalReload = setInterval(() => {
      this.getResults()
    }, 45000)*/
  },
  beforeDestroy() {
    //clearInterval(this.IntervalReload)
    clearTimeout(this.TimeoutReload)
  }
}
</script>
<style lang="scss">
body {
  margin: 0;
  padding: 0;
  background-image: url('../assets/theme/bg.png');
  background-repeat: repeat;
  background-position: center top;
  border-top: 15px solid #eac638;
  border-bottom: 15px solid #eac638;
  padding-bottom: 50px;
}

.mob {
  display: none;
}

.container-fluid {
  padding: 0;

  .header {
    margin-top: 5px;
    margin: 0 auto;
    max-width: 970px;
    width: 100%;

    .logo {
      img {
        height: 100px;
      }
    }
    .menu {
      margin-top: -20px;

      ul {
        padding: 0;
        margin: 0;
        text-align: right;
        li {
          list-style: none;
          display: inline;
          text-align: center;
          margin: 0 12px;
          font-size: 1.2rem;
          a {
            color: #FFF;
          }
        }
      }
    }
  }

  .content {

    .top-banner {
      margin: 0 auto;
      width: 970px;
      margin-top: 0px;
      max-width: 100%;

      img {
        width: 970px;
        max-width: 100%;
      }
    }

    .lotto {
      margin: 0 auto;
      width: 970px;
      display: flex;
      max-width: 100%;

      .left {
        width: 65%;
        margin-right: 20px;
        .lotto-head {
          display: flex;
          .lotto-logo {
            width: 400px;
            img {
              width: 100%;
            }
          }
          .lotto-date {
            width: 300px;
            color: #FFF;
            strong {
              font-size: 1.2rem;
              font-style: italic;
              font-weight: bold;
              line-height: 1;
              margin-left: 30px;
            }
            .date {
              font-family: sans-serif;
              text-align: center;
              font-size: 2.5rem;
              line-height: 1;
            }
          }
        }
      }
      .right {
        width: 35%;
        .banner {
          margin-top: 10px;
          text-align: center;
          img {
            max-width: 100%;
          }
        }
        .history {
          height: 100%;
          background-color: #fff;
          padding: 10px;

          .list {
            margin-bottom: 10px;
            border:1px solid #E00816;

            h2 {
              font-size: 1.2rem;
              background-color: #E00816;
              color: #fff;
              padding-left: 5px;
              margin-bottom: 0;
              text-align: center;
            }
            .prize {
              display: flex;
              padding-bottom: 5px;
              .prize-box {
                width: 50%;
                text-align: center;

                .p-number {
                  font-weight: bold;
                  font-size: 1.5rem;
                  line-height: 1;
                }
              }
            }
          }
        }
      }
    }

    .lotto-box {
      margin-top: 15px;
      min-height: 400px;
      padding: 20px 10px;
      margin-bottom: 100px;

      .lotto-content {
        margin-top: 10px;
        width: 100%;
        height: 380px;
        .number-box {
          display: flex;
          .number-l {
            width: 60%;
            padding: 0 10px;
            margin-right: 10px;
            .n-award {
              margin-top: 10px;
            }
            .spin-numbers {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 5px;
              .number {
                width: 55px;
                text-align: center;
                img {
                  max-width: 100%;
                }
              }
            }

            .number1st {
              .n-body {
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 80px;

                h1 {
                  font-size: 5rem;
                  line-height: 1;
                  letter-spacing: 3px;
                }
                .wloading {
                  img {
                    width: 40px;
                    margin: 10px 5px;
                  }
                }
              }
            }
            .number2nd {
              .n-body {
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 80px;

                h1 {
                  font-size: 4rem;
                  line-height: 1;
                  letter-spacing: 3px;
                }
                .wloading {
                  img {
                    width: 35px;
                    margin: 5px 5px;
                  }
                }
              }
            }
          }
          .number-r {
            width: 40%;
            margin-right: 10px;

            .time {
              width: 100%;
              height: 77px;
              background-size: 100% 100%;
            }

            .number3rd {
              margin-top: 25px;

              .n-body {
                display: flex;
                flex-wrap: wrap;
                .n-list {
                  width: 50%;
                  height: 50px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  h1 {
                    font-size: 2rem;
                    font-weight: normal;
                    line-height: 1;
                    margin-bottom: 0;
                  }
                  .wloading {
                    img {
                      width: 18px;
                      margin: 1px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .gb-box {
      background-image: url('../assets/theme/gb-bg.png');
      background-repeat: no-repeat;
      background-size: cover;

      .lotto-content {
        background-image: url('../assets/theme/gb-bg2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .number-box {
          .number-l {
            .number1st {
              margin-top: 20px;
              .n-head {
                height: 21px;
                background-color: #FE0000;
                background-image: url('../assets/theme/gb/1st.png');
                background-repeat: no-repeat;
                background-size: center center;
                line-height: 1;
                font-weight: bold;
                color: #FFF;
                display: flex;
                padding-left: 10px;
                align-items: center;
                font-size: 1.1rem;
              }
            }
            .number2nd {
              margin-top: 25px;
              .n-head {
                height: 21px;
                background-color: #FE0000;
                background-image: url('../assets/theme/gb/1st.png');
                background-repeat: no-repeat;
                background-size: center center;
                line-height: 1;
                font-weight: bold;
                color: #FFF;
                display: flex;
                padding-left: 10px;
                align-items: center;
                font-size: 1.1rem;
              }
            }
          }
          .number-r {
            .time {
              //width: 240px;
              //height: 77px;
              margin-top: 10px;
              background-image: url('../assets/theme/gb/time.png');
              background-repeat: no-repeat;
              //background-size: 240px 77px;
              padding-top: 15px;
              text-align: center;
              span {
                font-family: sans-serif;
                font-size: 45px;
              }
            }
            .number3rd {
              .n-head {
                height: 21px;
                background-color: #FE0000;
                background-image: url('../assets/theme/gb/1st.png');
                background-repeat: no-repeat;
                background-size: center center;
                line-height: 1;
                font-weight: bold;
                color: #FFF;
                display: flex;
                padding-left: 10px;
                align-items: center;
                font-size: 1.1rem;
              }
            }
          }
        }
      }
    }

    .de-box {
      background-image: url('../assets/theme/de-bg.png');
      background-repeat: no-repeat;
      background-size: cover;

      .lotto-content {
        background-image: url('../assets/theme/de-bg2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .number-box {
          .number-l {
            .spin-numbers {
              background-image: url('../assets/theme/de/n-box.png');
              padding: 10px;
              background-size: 100% 100%;
              .number {
                text-align: center;
                img {
                  width: 45px;
                }
              }
            }
            .number1st {
              margin-top: 10px;
              .n-head {
                height: 21px;
                background-color: #FE0000;
                background-image: url('../assets/theme/de/1st.png');
                background-repeat: no-repeat;
                background-size: center center;
                line-height: 1;
                font-weight: bold;
                color: #FFF;
                display: flex;
                padding-left: 10px;
                align-items: center;
                font-size: 1.1rem;
              }
              .n-body {
                h1 {
                  color: #FFF;
                }
              }
            }
            .number2nd {
              margin-top: 20px;
              .n-head {
                height: 21px;
                background-color: #FE0000;
                background-image: url('../assets/theme/de/1st.png');
                background-repeat: no-repeat;
                background-size: left center;
                line-height: 1;
                font-weight: bold;
                color: #FFF;
                display: flex;
                padding-left: 10px;
                align-items: center;
                font-size: 1.1rem;
              }
              .n-body {
                h1 {
                  color: #FFF;
                }
              }
            }
          }
          .number-r {
            .time {
              //width: 240px;
              //height: 77px;
              margin-top: 15px;
              background-image: url('../assets/theme/de/time.png');
              background-repeat: no-repeat;
              //background-size: 240px 77px;
              padding-top: 17px;
              text-align: center;
              span {
                font-family: sans-serif;
                font-size: 45px;
              }
            }
            .number3rd {
              .n-head {
                height: 21px;
                background-color: #FE0000;
                background-image: url('../assets/theme/de/1st.png');
                background-repeat: no-repeat;
                background-size: center center;
                line-height: 1;
                font-weight: bold;
                color: #FFF;
                display: flex;
                padding-left: 10px;
                align-items: center;
                font-size: 1.1rem;
              }
              .n-body {
                .n-list {
                  color: #FFF;
                }
              }
            }
          }
        }
      }

      .right {
        .history {
          .list {
            border-color: #030303;
            h2 {
              background-color: #030303;
            }
          }
        }
      }
    }

    .ru-box {
      background-image: url('../assets/theme/ru-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
      margin-bottom: 20px;

      .lotto-content {
        background-image: url('../assets/theme/ru-bg2.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .number-box {
          .number-l {
            .n-award {
              margin-top: 20px;
            }
            .spin-numbers {
              margin-top: -5px;
              .number {
                width: 55px;
                text-align: center;
                img {
                  width: 95px;
                  max-width: 95px;
                  margin-left: -20px;
                }
              }
            }
            .number1st {
              margin-top: 0px;
              .n-head {
                height: 21px;
                background-color: #FFF;
                line-height: 1;
                font-weight: bold;
                color: #000;
                display: flex;
                padding-left: 10px;
                align-items: center;
                font-size: 1.1rem;
              }
              .n-body {
                h1 {
                  color: #FFF;
                }
              }
            }
            .number2nd {
              margin-top: 25px;
              .n-head {
                height: 21px;
                background-color: #FFF;
                line-height: 1;
                font-weight: bold;
                color: #000;
                display: flex;
                padding-left: 10px;
                align-items: center;
                font-size: 1.1rem;
              }
              .n-body {
                h1 {
                  color: #FFF;
                }
              }
            }
          }
          .number-r {
            .time {
              //width: 240px;
              //height: 77px;
              margin-top: 15px;
              background-image: url('../assets/theme/ru/time.png');
              background-repeat: no-repeat;
              //background-size: 240px 77px;
              padding-top: 18px;
              text-align: center;
              span {
                font-family: sans-serif;
                font-size: 45px;
              }
            }
            .number3rd {
              .n-head {
                height: 21px;
                background-color: #FFF;
                line-height: 1;
                font-weight: bold;
                color: #000;
                display: flex;
                padding-left: 10px;
                align-items: center;
                font-size: 1.1rem;
              }
              .n-body {
                .n-list {
                  color: #FFF;
                }
              }
            }
          }
        }
      }

      .right {
        .history {
          .list {
            border-color: #110E31;
            h2 {
              background-color: #110E31;
            }
          }
        }
      }
    }

  }
}

@media only screen and (max-width:850px) {
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .time {
    padding-top: 20px;
  }
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .time span {
    font-size: 40px;
  }
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .number3rd .n-body .n-list h1 {
    font-size: 1.6rem;
  }
}

@media only screen and (max-width:768px) {
  .container-fluid .header {
    padding: 0 10px;
  }
  .container-fluid .content .top-banner {
    padding: 0 10px;
  }
  .container-fluid .content .lotto {
    justify-content: center;
    align-items: center;
  }
  .container-fluid .content .lotto .right {
    display: none;;
  }
  .container-fluid .content .lotto .left {
    margin-right: 0px;
    width: 100%;
  }
}

@media only screen and (max-width:669px) {
  .container-fluid {
    .header {
      .logo {
        text-align: center;
      }
      .menu {
        display: none;
      }
    }
    .content {
      .top-banner {
        padding: 0 5px;
      }
      .lotto-box {
        padding: 20px 0px;
        .lotto {
          .left {
            width: 100%;
            margin-right: 0px;
            padding: 0 5px;
            .lotto-content {
              width: 100%;
              background-size: 100% 100%;
            }
          }
          .right {
            display: none;
          }
        }
      }
    }
  }
}

@media only screen and (max-width:599px) {
  .container-fluid .content .lotto-box .lotto-content .number-box .number-l {
    padding: 0 10px;
    margin-right: 10px;
  }
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r {
    width: 200px;
    .time {
      max-width: 100%;
      background-size: 100% 100%;
    }
  }
  .container-fluid .content .lotto-box .lotto-content .number-box .number-l .spin-numbers .number {
    width: 50px;
  }
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .number3rd .n-body .n-list .wloading img {
    width: 15px;
  }
  .container-fluid .content .ru-box .lotto-content .number-box .number-l .spin-numbers .number img {
    width: 85px;
    max-width: 85px;
    margin-left: -17px;
  }
}

@media only screen and (max-width:499px) {
  .container-fluid .header .logo img {
    height: auto;
    max-width: 90%;
  }
  .container-fluid .content .lotto .left .lotto-head {
    display: block;
    .lotto-logo {
      width: 100%;
      text-align: center;
      img {
        width: 300px;
        max-width: 80%;
      }
    }
    .lotto-date {
      margin: 0 auto;
      margin-top: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      strong {
        margin: 0;
        margin-right: 15px;
      }
    }
  }
  .container-fluid .content .lotto-box .lotto-content {
    height: 530px;

    .number-box {
      display: block;
      .number-l {
        width: 100%;
        padding: 0 10px;
        margin-right: 0;
        padding-top: 5px;
      }
      .number-r {
        width: 100%;
        padding: 0 10px;
        margin-right: 0;

        .time {
          display: none;
        }

        .number3rd {
          .n-body {
            .n-list {
              width: 25%;
            }
          }
        }
      }
    }
  }
  .container-fluid .content .de-box .lotto-content .number-box .number-l .spin-numbers .number {
    width: 55px;
  }
  .container-fluid .content .ru-box .lotto-content .number-box .number-l {
    .spin-numbers {
      margin-top: 0;
      .number {
        width: 55px;
        height: 90px;
        img {
          width: 75px;
          max-width: 75px;
          margin-left: -10px;
        }
      }
    }
  }
  .container-fluid .content .ru-box .lotto-content .number-box .number-l .spin-numbers .number img {
    width: 95px;
    max-width: 95px;
    margin-left: -20px;
    margin-top: -5px;
  }
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .number3rd .n-body .n-list h1 {
    font-size: 1.5rem;

  }
}

@media only screen and (max-width:399px) {
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .number3rd .n-body .n-list .wloading img {
    width: 14px;
  }
}
@media only screen and (max-width:360px) {
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .number3rd .n-body .n-list .wloading img {
    width: 13px;
  }
}

@media only screen and (max-width:349px) {
  .container-fluid .content .lotto-box .lotto-content {
    height: 590px;
  }
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .number3rd {
    margin-top: 15px;
  }
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .number3rd .n-body .n-list {
    width: 50%;
    height: 40px;
  }
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .number3rd .n-body .n-list h1 {
    font-size: 1.5rem;
  }
  .container-fluid .content .lotto-box .lotto-content .number-box .number-r .number3rd .n-body .n-list .wloading img {
    width: 18px;
  }
}
</style>
